const {
  zipCodeRegexNumeric,
  onlyNumericNormalize,
  SPACE,
  COMMA
} = require('../helpers');

exports.zipCodeNormalize = (zipCode) => onlyNumericNormalize(zipCode, 5);

exports.countryDefinition = {
  country: 'Mexico',
  code: 'MX',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    stateCode: { label: 'Province Abbreviation' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city', COMMA, 'stateCode']
  ],
  formFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', 'city'],
    ['stateCode']
  ],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    { field: 'stateCode' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(zipCodeRegexNumeric(5)),
      error: 'Must be 5 numbers, 02860'
    }
  ]
};
